import { memo } from 'react'
import cn from 'clsx'
import { isEqual } from 'lodash'

import { Link } from '@tracklib/kit'
import styles from './tabs.css'

type TabsProps = {
  items: Array<{ id: string | number; to: string; query: Record<string, unknown>; label: string }>
  activeQuery?: string
}

const Tabs = ({ items, activeQuery }: TabsProps): JSX.Element => {
  return (
    <nav className={styles.tabs}>
      {items.map(item => (
        <Link
          key={item.id}
          to={item.to}
          query={item.query ? item.query : undefined}
          className={cn(styles.item, activeQuery && item.query && isEqual(activeQuery, item.query) && styles.itemActive)}
        >
          {item.label}
        </Link>
      ))}
    </nav>
  )
}

export default memo(Tabs)
